import SessionAuthenticationService from './SessionAuthenticationService';

export default SessionAuthenticationService;
